export const ProductType = Object.freeze({
  BEGINNER: 'BEGINNER',
  ADVANCED: 'ADVANCED'
})
